exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vlSelected[data-v-06ce996a] {\n  font-weight: bold;\n}", ""]);

// exports
